import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import Button from "../../Button";
import "../_modal.scss";
import "./_index.scss";

const ConfirmResetModal = ({ id, open, handleClose, data }) => {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick" && reason !== "escapeKeyDown") {
          handleClose(id);
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="ta-modal confirm-reset-modal"
    >
      <div className="confirm-reset-modal-wrapper">
        <div className="modal-confirm">
          <div className="modal-content">
            <div className="modal-header">
              <Button
                type="button"
                className="close"
                onClick={() => handleClose(id)}
                rightIcon={<CloseIcon />}
              />
            </div>
            <DialogContent>
              <div className="modal-text">
                Are you sure you want to reset all remote days for all employees?
                <br /><br />
                <strong>This action will:</strong>
                <ul>
                  <li>Set 10 days for employees with positive or zero balance</li>
                  <li>Set 10 + negative_balance for employees with negative balance</li>
                  <li>This process cannot be undone</li>
                </ul>
              </div>
              <div className="modal-actions">
                <Button
                  type="button"
                  text="Cancel"
                  className="cancel-btn"
                  onClick={() => handleClose(id)}
                />
                <Button
                  type="button"
                  text="Reset All Remote Days"
                  className="reset-btn"
                  onClick={data?.resetHandler}
                />
              </div>
            </DialogContent>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmResetModal;